<script setup lang="ts">
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import VBlockLoader from "@magnit/core/src/components/VLoader/VBlockLoader.vue";
import type { ICategory } from "@magnit/unit-catalog/src/unit-catalog.types";
import type { ICategoriesFunctions, IGoodsFilters } from "../types";
import CatalogFiltersDiscount from "./Discount.vue";
import CatalogFiltersRange from "./Range.vue";
import CatalogFiltersGrid from "./Grid.vue";
import FilterCategories from "./FilterCategories.vue";

defineProps<{
  category: ICategory;
  categoriesStore: ICategoriesFunctions;
  filters?: IGoodsFilters | null;
  loading?: boolean;
  countChange?: number;
  hideCategories?: boolean;
}>();

const emit = defineEmits<{
  reset: [];
}>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: позднее подробнее описать тип фильтров и избавиться от any. Пока для быстрого переноса увы так
const modelValue = defineModel<Record<string, any>>({ default: {} });

const onReset = () => {
  emit("reset");
};
</script>

<template>
  <div class="unit-catalog-filters">
    <VBlockLoader :show="loading" absolute only-overlay />
    <FilterCategories
      v-if="!hideCategories"
      :category-key="category.key"
      :categories-store="categoriesStore"
      data-test-id="filters-category"
    />
    <CatalogFiltersDiscount
      v-if="categoriesStore.getTypeByKey(category.key) === 'goods'"
      v-model="modelValue['onlyDiscount']"
    />
    <div v-for="filter in filters?.filters" :key="filter.id">
      <CatalogFiltersRange
        v-if="
          filter.type === 'range' && Object.keys(filter).includes('minValue')
        "
        v-model="modelValue[filter.id]"
        :filter="filter"
        :data-test-id="`filter-${filter.id}`"
      />
      <CatalogFiltersGrid
        v-else-if="filter.type === 'grid' && !!filter.elements?.length"
        v-model="modelValue[filter.id]"
        :filter="filter"
        :data-test-id="`filter-${filter.id}`"
      />
    </div>
    <div class="unit-catalog-filters__controls">
      <VButton
        v-if="countChange"
        theme="secondary"
        size="l"
        class="unit-catalog-filters__button"
        full-width
        @click="onReset"
      >
        Сбросить всё
      </VButton>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.unit-catalog-filters {
  padding-top: var(--pl-unit-x1);
  display: flex;
  flex-direction: column;
  position: relative;

  &__controls {
    padding-top: var(--pl-unit-x4);
    position: sticky;
    bottom: var(--pl-unit-x2);
    z-index: var(--pl-z-index-level2);
  }
}
</style>
